import React from "react";
import { Flex, Text, Button, Divider } from "@aws-amplify/ui-react";
import { LuUndo2 } from "react-icons/lu";

export default function CompletedTodoItem({ data, handleUndo }) {
  return (
    <Flex direction={"column"} gap={1}>
      <Flex justifyContent="flex-end">
        <Button size="small" colorTheme="warning" variation="link" onClick={handleUndo.bind(this, data?.id)}>
          <LuUndo2 /> 
        </Button>
      </Flex>
      <Text
        isTruncated={true}
        variation="tertiary"
        fontSize={14}
        children={data?.todoDescription}
      />
      <Text
        variation="tertiary"
        fontSize={12}
        children={`Completed: ${data?.updatedAt}`}
      />
      <Text
        variation="tertiary"
        fontSize={12}
        children={`Completed by: ${data?.updatedByName}`}
      />
      <Divider size="small" />
    </Flex>
  );
}
